import { gallerySectionTechSol } from "data/gallerySection";
import useActive from "hooks/useActive";
import Link from "next/link";
import React, { useState } from "react";
// import Masonry from "react-masonry-component";
import GalleryItem from "./GalleryItem";
import { useAppStore } from "lib/store";
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import path from 'path';
import { IconButton, ImageListItemBar, Typography } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import MansonryLoader from "components/MansonryLoader/MansonryLoader";
const masonryOptions = {
  transitionDuration: 500,
};

const { title, tabBtns, items } = gallerySectionTechSol;

const getCurrentItems = (current = "") =>
  items.filter((it) => it.filter.includes(current));

const getCount = (current = "") => getCurrentItems(current).length;



const GallerySectionTechSol = ({ portfolio = false, similar = false }) => {

  const { loading, error, techSolutions, productNames } = useAppStore();
  const [current, setCurrent] = useState("all");
  const currentItems = getCurrentItems(current);
  const ref = useActive("#portfolio");

  // Filter the data based on the search term and all columns
  //   const filteredData = reports.filter((item) =>
  //   Object.values(item).some((value) =>
  //     typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  // );
  // const rows = filteredData.map(r => (
  //   createData(r.description, r.id, r.type, r.timestamp, r.age, r.losses, '*', r.createdAt)
  // ))


  return (
    <section
      ref={ref}
      className={`gallery-section${similar ? " similar-gallery" : ""}`}
      id="portfolio"
    >
      <div className="auto-container">
        <div className="sec-title centered">
          <h2>
            Our Products
            <span className="dot">.</span>
          </h2>
        </div>
        <div className="mixitup-gallery">
          <div className={portfolio || similar ? "" : "upper-row clearfix"}>
            {!portfolio && (
              <div className={`sec-title${similar ? " centered" : ""}`}>
                <h2>
                  {similar ? "Similar work " : title}
                  <span className="dot">.</span>
                </h2>
              </div>
            )}
            {!similar && (
              <div
                className={`filters clearfix${portfolio ? " centered" : ""}`}
              >
                <ul className="filter-tabs filter-btns clearfix">
                  {productNames.map((name, index) => (
                    <Typography
                      variant="body1"
                      color={'GrayText'}
                      fontSize={25}
                      display={'inline-flex'}
                      key={`${title}${index}`}
                    >
                      {name} <b style={{paddingLeft:1, paddingRight:1, color:'darkorange'}}>|</b>
                    </Typography>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <Box sx={{ width: '100%', height: 450, overflowY: 'scroll' }}>
            <ImageList variant="masonry" cols={3} gap={8}>
              {Array(techSolutions.total).fill(0).slice(0, Array(techSolutions.total).length).map((item, index) => (
                index != 0 && <MansonryLoader
                  key={`${techSolutions.title}-${index}`}
                  title={techSolutions.title}
                  count={index}
                  path={techSolutions.path}
                  alt='Tech-Solutions' />
              ))}
            </ImageList>
          </Box>
        </div>
      </div>
    </section>
  );
};

export default GallerySectionTechSol;
